/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Completed/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Simple/Data/format.js'
import LaunchIteroAction from './LaunchIteroAction/index'
import OneShotAction from './OneShotAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Completed({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/AlignItero/Content/Content/Content/Completed"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let constantData = 'Scan generated on'
let iteroScanCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'itero_scan',
path: 'created_at',
format: fromFormat.dateISOIn,
})
let constantData1 = 'at'
let iteroScanCreatedAtValueData1 = fromData.useDataFormat({ viewPath,
context: 'itero_scan',
path: 'created_at',
format: fromFormat.dateISOToTime,
})
let aggregateData = fromAggregate.join(constantData, iteroScanCreatedAtValueData, constantData1, iteroScanCreatedAtValueData1)
  return (<React.Fragment
>
<div
  data-testid="Completed.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-HoWtB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceS}
 data="'Scan generated on'"
 data="itero_scan.created_at"
 format="/Simple/Data/format.js dateISOIn"
 data="'at'"
 data="itero_scan.created_at"
 format="/Simple/Data/format.js dateISOToTime"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
<LaunchIteroAction
  viewPath={`${viewPath}/LaunchIteroAction`}
/>
</div>
<OneShotAction
  viewPath={`${viewPath}/OneShotAction`}
/>
{children}
</React.Fragment>)
}